const VimeoIcon = (): JSX.Element => (
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 24 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<g clipPath="url(#clip0_5903_136765)">
			<mask
				id="mask0_5903_136765"
				style={{ maskType: 'luminance' }}
				maskUnits="userSpaceOnUse"
				x="0"
				y="0"
				width="24"
				height="24"
			>
				<path d="M24 0H0V24H24V0Z" fill="white" />
			</mask>
			<g mask="url(#mask0_5903_136765)">
				<path
					d="M20.4 0H3.6C1.61178 0 0 1.61178 0 3.6V20.4C0 22.3882 1.61178 24 3.6 24H20.4C22.3882 24 24 22.3882 24 20.4V3.6C24 1.61178 22.3882 0 20.4 0Z"
					fill="#1EB8EB"
				/>
				<path
					d="M19.5938 8.67194C18.7031 13.7813 13.5938 18.1407 12.0469 19.1251C10.5469 20.1094 9.14064 18.7031 8.62496 17.7188C8.06248 16.5 6.32813 10.0313 5.85938 9.46882C5.43751 8.90626 4.03125 10.0313 4.03125 10.0313L3.42188 9.14066C3.42188 9.14066 6.18751 5.81254 8.29688 5.43754C10.5 4.96879 10.5 8.85938 11.0625 10.9688C11.5782 13.0782 11.9062 14.25 12.3282 14.25C12.7969 14.25 13.6875 13.1251 14.625 11.2969C15.6094 9.5625 14.5782 7.96879 12.7031 9.09378C13.5 4.64066 20.4844 3.56254 19.5938 8.67194Z"
					fill="white"
				/>
			</g>
		</g>
		<defs>
			<clipPath id="clip0_5903_136765">
				<rect width="24" height="24" fill="white" />
			</clipPath>
		</defs>
	</svg>
)

export default VimeoIcon
